//buildScene.js
import { createScene } from './scene/Scene';

export function buildScene({ ImageItem, PointItem, WORLD_ORIGIN }) {
  const scene = createScene();
  const stageById = new Map();
  const pointById = new Map();

  // 마우스 오버시 등장 이미지
  scene.addHoverOverlay(
    '0막',
    ImageItem(
      '0막_overlay',
      '/images/stage0_img.png',
      WORLD_ORIGIN.x + 623,
      WORLD_ORIGIN.y + 229,
    ),
  );
  scene.addHoverOverlay(
    '1막',
    ImageItem(
      '1막_hover',
      '/images/stage1_img.png',
      WORLD_ORIGIN.x + 1206,
      WORLD_ORIGIN.y + 308,
    ),
  );
  scene.addHoverOverlay(
    '2-1막',
    ImageItem(
      '2-1막_hover',
      '/images/stage2-1_img.png',
      WORLD_ORIGIN.x + 304,
      WORLD_ORIGIN.y + 954,
    ),
  );
  scene.addHoverOverlay(
    '2-2막',
    ImageItem(
      '2-2막_hover',
      '/images/stage2-2_img.png',
      WORLD_ORIGIN.x + 1383,
      WORLD_ORIGIN.y + 967,
    ),
  );
  scene.addHoverOverlay(
    '3막',
    ImageItem(
      '3막_hover',
      '/images/stage3_img.png',
      WORLD_ORIGIN.x + 2028,
      WORLD_ORIGIN.y + 396,
    ),
  );
  scene.addHoverOverlay(
    '4-1막',
    ImageItem(
      '4-1막_hover',
      '/images/stage4-1_img.png',
      WORLD_ORIGIN.x + 2373,
      WORLD_ORIGIN.y + 167,
    ),
  );
  scene.addHoverOverlay(
    '4-2막',
    ImageItem(
      '4-2막_hover',
      '/images/stage4-2_img.png',
      WORLD_ORIGIN.x + 3284,
      WORLD_ORIGIN.y + 237,
    ),
  );
  scene.addHoverOverlay(
    '5-1막',
    ImageItem(
      '5-1막_hover',
      '/images/stage5-1_img.png',
      WORLD_ORIGIN.x + 2373,
      WORLD_ORIGIN.y + 1307,
    ),
  );
  scene.addHoverOverlay(
    '5-2막',
    ImageItem(
      '5-2-1막_hover',
      '/images/stage5-2-1_img.png',
      WORLD_ORIGIN.x + 3345,
      WORLD_ORIGIN.y + 1099,
    ),
  );
  scene.add(
    ImageItem(
      '5-2-2막_hover',
      '/images/stage5-2-2_img.png',
      WORLD_ORIGIN.x + 3345,
      WORLD_ORIGIN.y + 1099,
    ),
  );

  // 막
  function addStage(id, imgSrc, x, y) {
    const item = ImageItem(id, imgSrc, x, y);
    // scene.addHoverTarget(item);
    scene.add(item);
    stageById.set(id, item);
    return item;
  }

  function addPoint(id, x, y) {
    const p = PointItem(
      id,
      '/images/point_normal.png',
      '/images/point_active.png',
      x,
      y,
    );
    scene.addHoverTarget(p);
    pointById.set(id, p);
    return p;
  }

  // 0막
  addStage(
    '0막',
    '/images/stage0_w.png',
    WORLD_ORIGIN.x + 244,
    WORLD_ORIGIN.y + 88,
  );

  addPoint('0막', WORLD_ORIGIN.x + 646, WORLD_ORIGIN.y + 403);

  // 1막
  addStage(
    '1막',
    '/images/stage1_w.png',
    WORLD_ORIGIN.x + 971,
    WORLD_ORIGIN.y + 188,
  );

  addPoint('1막', WORLD_ORIGIN.x + 1530, WORLD_ORIGIN.y + 257);

  // 2막
  addStage(
    '2-1막',
    '/images/stage2-1_w.png',
    WORLD_ORIGIN.x + 198,
    WORLD_ORIGIN.y + 1215,
  );

  addPoint('2-1막', WORLD_ORIGIN.x + 996, WORLD_ORIGIN.y + 1227);

  addStage(
    '2-2막',
    '/images/stage2-2_w.png',
    WORLD_ORIGIN.x + 1270,
    WORLD_ORIGIN.y + 1118,
  );

  addPoint('2-2막', WORLD_ORIGIN.x + 1709, WORLD_ORIGIN.y + 1307);

  // 3막
  addStage(
    '3막',
    '/images/stage3_w.png',
    WORLD_ORIGIN.x + 1578,
    WORLD_ORIGIN.y + 81,
  );

  addPoint('3막', WORLD_ORIGIN.x + 2209, WORLD_ORIGIN.y + 824);

  // 4막
  addStage(
    '4-1막',
    '/images/stage4-1_w.png',
    WORLD_ORIGIN.x + 2182,
    WORLD_ORIGIN.y + 65,
  );
  addStage(
    '4-2막',
    '/images/stage4-2_w.png',
    WORLD_ORIGIN.x + 2662,
    WORLD_ORIGIN.y + 199,
  );

  addPoint('4-2막', WORLD_ORIGIN.x + 3364, WORLD_ORIGIN.y + 530);
  addPoint('4-1막', WORLD_ORIGIN.x + 2623, WORLD_ORIGIN.y + 587);

  // 5막
  addStage(
    '5-1막',
    '/images/stage5-1_w.png',
    WORLD_ORIGIN.x + 2352,
    WORLD_ORIGIN.y + 1194,
  );
  addStage(
    '5-2막',
    '/images/stage5-2_w.png',
    WORLD_ORIGIN.x + 3198,
    WORLD_ORIGIN.y + 1186,
  );

  addPoint('5-1막', WORLD_ORIGIN.x + 2786, WORLD_ORIGIN.y + 1229);
  addPoint('5-2막', WORLD_ORIGIN.x + 3502, WORLD_ORIGIN.y + 1459);

  return { scene, stageById, pointById };
}
